import React from "react"

export const ReleaseToggle = () => {
    return <cj-feature-toggle/>
}